module.exports = __webpack_public_path__ + "img/key_features--frame_based_lateral_tilt.91d6e12c.jpg";